// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M7.7 13.5H3.5C2.4 13.5 1.5 12.6 1.5 11.5V4.25C1.5 3.15 2.4 2.25 3.5 2.25H5.15C5.65 2.25 6.08 2.48 6.4 2.86L6.88 3.43C7.2 3.81 7.63 4.05 8.13 4.05H12.5C13.6 4.05 14.5 4.95 14.5 6.05V7',
  'M13.75 10.85C13.75 12.07 12.77 13.05 11.55 13.05C10.33 13.05 9.35 12.07 9.35 10.85C9.35 9.63 10.33 8.65 11.55 8.65C12.77 8.65 13.75 9.63 13.75 10.85Z',
  'M13.11 12.41L14.5 13.8',
];
